module.exports = __webpack_public_path__ + "static/media/firefox-browser.b49e1e34.svg";